import React from 'react'
import { IProps } from './index'
import { Color, getColorTheme, mq } from '../../utils'
import { SpecialThemeColor } from '../../utils/constants/themes'
import { Text } from 'marketing-site/src/library/elements/Text'

interface ILocalTheme {
  bannerColor: SpecialThemeColor
  textColor: SpecialThemeColor
}

function getLocalTheme(bgColor: SpecialThemeColor): ILocalTheme {
  const baseColors = getColorTheme('default', bgColor)

  switch (bgColor) {
    case Color.Blue:
      return {
        ...baseColors,
        bannerColor: Color.Blue,
        textColor: Color.White,
      }
    case Color.White:
      return {
        ...baseColors,
        bannerColor: Color.White,
        textColor: Color.Slate,
      }
    case Color.Slate:
      return {
        ...baseColors,
        bannerColor: Color.Slate,
        textColor: Color.White,
      }
    default:
      return {
        ...baseColors,
        bannerColor: Color.Blue,
        textColor: Color.White,
      }
  }
}

export const LongBanner: React.FC<IProps> = (props) => {
  const { bgImage, renderCTA, bgColor, text } = props
  const themeColors = getLocalTheme(bgColor)

  return (
    <div className="long-banner">
      <div className="long-banner__content">
        {text && (
          <span className="long-banner__text">
            <Text brand="default" size={'body-bold'}>
              {text}
            </Text>
          </span>
        )}
        {renderCTA && <span className="long-banner__cta">{renderCTA()}</span>}
      </div>
      <style jsx>
        {`
          .long-banner {
            display: block;
            width: 100%;
            min-height: 3.5rem;
            padding: 19px 24px;
            background-color: ${themeColors.bannerColor};
            background-image: ${bgImage?.url ? `url(${bgImage.url})` : 'none'};
            background-repeat: repeat;
            background-position: center;
            background-size: cover;

            .long-banner__content {
              display: flex;
              justify-content: center;
              width: 100%;
            }
            .long-banner__text {
              display: inline-block;
              line-height: 1.485rem;
              color: ${themeColors.textColor};
              margin-right: 10px;

              span {
                display: inline-block;
                text-align: center;
                line-height: 1.485rem;
                color: ${themeColors.textColor};
              }
            }
            .long-banner__cta {
              display: inline-block;
              text-align: center;
              line-height: 1.485rem;
              color: ${themeColors.textColor};
            }
          }
          @media (${mq.mobile}) {
            .long-banner {
              .long-banner__content {
                display: block;
                .long-banner__cta {
                  width: 100%;
                }
                .long-banner__text {
                  width: 100%;
                  text-align: center;
                  span {
                    display: inline-block;
                    width: 100%;
                  }
                }
              }
            }
          }
          @media (${mq.laptop}) {
            .long-banner {
              height: 5rem;

              .long-banner__content {
                padding-top: 0.7rem;
              }

              .long-banner__text {
                line-height: 1.485rem;

                span {
                  line-height: 1.485rem;
                }
              }
            }
          }
        `}
      </style>
    </div>
  )
}
